import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import Card from '../config/ChowaCard';
import { getEngineHours } from '../api_config';

const ModelRegistrationCard = ({ selectedModel, seriesColor }) => {
  const [modelTotal, setModelTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!selectedModel) {
      setModelTotal(0);
      setLoading(false);
      return;
    }

    const fetchModelTotal = async () => {
      try {
        const response = await getEngineHours(selectedModel);
        if (response.data?.data) {
          setModelTotal(response.data.data.length);
        }
      } catch (error) {
        console.error('モデル合計の取得に失敗:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchModelTotal();
  }, [selectedModel]);

  return (
    <Card style={{ padding: '24px', textAlign: 'center', borderRadius: '16px', borderColor: seriesColor, borderWidth: '2px' }}>
      <Typography variant="h6" sx={{ mb: 2, color: seriesColor, fontWeight: 600 }}>
        {selectedModel || '選択モデル'}登録台数
      </Typography>
      {!selectedModel ? (
        <Typography variant="h4" sx={{ fontWeight: 600, color: seriesColor }}>
          -
        </Typography>
      ) : loading ? (
        <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
      ) : (
        <Typography variant="h4" sx={{ fontWeight: 600, color: seriesColor }}>
          {modelTotal}台
        </Typography>
      )}
    </Card>
  );
};

export default ModelRegistrationCard; 